import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchAllPermissions = createAsyncThunk('getAllPermissions/fetchAllPermissions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.get(api.permissions.getAll);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getAllPermissionListSlice = createSlice({
  name: 'Permissions',
  initialState: {
    permissions: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchAllPermissions.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchAllPermissions.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.permissions = action.payload;
        })
      .addCase(fetchAllPermissions.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getAllPermissionListSlice.reducer;